import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PageHeader from "../-components/PageHeader";
import ConsoleHrozontalHeadTable from "../-components/ConsolehorizontalHeadTable";
import LoadingPop from "components/popup/LoadingPop";
import ConfirmDialog from "components/popup/ConfirmDialog";
import Seo from "components/Seo";
import DriverScheduleForm, { DriverScheduleFormState } from "./DriverScheduleForm";
import { useGetConsoleDriverScheduleDetail, useDeleteConsoleDriverSchedule } from "hooks/console/useConsoleDriverSchedule";

export default function ConsoleDriverScheduleDetail() {
    const navigate = useNavigate();
    const location = useLocation();
    const idx = useParams().idx ?? "";
    const page = location.state?.page ?? "1";
    const [editMode, setEditMode] = useState(false);
    const { data, isLoading } = useGetConsoleDriverScheduleDetail(idx);
    const { mutate: deleteSchedule } = useDeleteConsoleDriverSchedule(() =>
        navigate(`/morning/customer/driver-schedule?page=${page}`),
    );
    const [form, setForm] = useState<DriverScheduleFormState>({
        schedule_no: null,
        schedule_nos: [],
        warehouse_no: "",
        driver_no: "",
        work_date: "",
        work_start_date: "",
        work_end_date: "",
    });

    useEffect(() => {
        if (data) {
            setForm({
                schedule_no: data.schedule_no,
                schedule_nos: data.schedule_nos ?? [data.schedule_no],
                warehouse_no: String(data.warehouse_no ?? ""),
                driver_no: String(data.driver_no ?? ""),
                work_date: data.work_date || "",
                work_start_date: data.work_start_date || data.work_date || "",
                work_end_date: data.work_end_date || data.work_date || "",
            });
        }
    }, [data]);

    const thead = [
        { title: "항구명", key: "port_name" },
        { title: "입고지명", key: "warehouse_name" },
        {
            title: "날짜",
            key: "work_date",
            // 연속 기간이면 '시작일 ~ 종료일 (N일)', 단일일은 그대로
            content: (_value: any, row: any) =>
                row?.work_start_date && row.work_start_date !== row.work_end_date
                    ? `${row.work_start_date} ~ ${row.work_end_date} (${row.day_count}일)`
                    : row?.work_start_date || row?.work_date || "",
        },
        { title: "담당기사", key: "driver_name" },
        { title: "전화번호", key: "phone" },
        { title: "차량번호", key: "car_no" },
    ];

    if (!idx) return <div>잘못된 접근입니다.</div>;

    return (
        <>
            <Seo type="console" pageTitle="일자별 입고지 기사 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="일자별 기사배정 상세" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        {isLoading ? (
                            <LoadingPop />
                        ) : data ? (
                            <div className="bg-white rounded-[20px] py-[36px] px-[40px] w-full min-w-[800px]">
                                {editMode ? (
                                    <DriverScheduleForm form={form} setForm={setForm} setEditMode={setEditMode} update />
                                ) : (
                                    <>
                                        <ConsoleHrozontalHeadTable thead={thead} tbody={data} />
                                        <div className="flex justify-center gap-x-[8px] mt-5">
                                            <button
                                                className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                onClick={() => setEditMode(true)}
                                            >
                                                수정
                                            </button>
                                            <ConfirmDialog
                                                title="일자별 기사배정 삭제"
                                                trigger={open => (
                                                    <button
                                                        type="button"
                                                        onClick={open}
                                                        className="text-[#666666] text-[18px] bg-white rounded-[5px] border border-[#dddddd] px-[55px] py-[15px]"
                                                    >
                                                        삭제
                                                    </button>
                                                )}
                                                handleConfirm={() =>
                                                    deleteSchedule({
                                                        // 기간(묶음) 등록이면 묶음 전체 삭제, 없으면 대표 1건
                                                        schedule_no:
                                                            data.schedule_nos && data.schedule_nos.length
                                                                ? data.schedule_nos
                                                                : [Number(idx)],
                                                    })
                                                }
                                            />
                                            <button
                                                onClick={() => navigate(`/morning/customer/driver-schedule?page=${page}`)}
                                                className="text-white text-[18px] bg-[#4F46E5] rounded-[5px] border border-[#666666] px-[55px] py-[15px]"
                                            >
                                                목록
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="bg-white rounded-[20px] flex flex-col gap-5 items-center justify-center py-[100px]">
                                <p>결과가 없습니다.</p>
                                <button onClick={() => navigate(-1)} className="rounded-[8px] border px-5 py-2">
                                    뒤로가기
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
